import { WebStorageStateStore } from "oidc-client-ts";

export const authConfig = {
  authority: window.ENV.SPA_AUTHORITY,
  client_id: window.ENV.SPA_CLIENT_ID,
  response_type: "code",
  scope: "openid offline groups builder.access",
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  automaticSilentRenew: false,
  revokeTokenTypes: ["access_token", "refresh_token"],
  revokeTokensOnSignout: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};
